var dt = require("datatables.net")(window, jQuery),
  dtUtils = require("../utils/dtUtils"),
  imagesloaded = require("imagesloaded");

function _getSeriesURL(data) {
  return window.SITE_SETTINGS.blogurl + "/series/" + data.series_name;
}

// Results table
var colData = [
  {
    title: "Series",
    func: function (data) {
      return (
        '<a href="' + _getSeriesURL(data) + '">' + data.series_name + "</a>"
      );
    },
    width: "90px",
    className: "col-emphasize",
  },
  {
    title: "Layout",
    prop: "layout_name",
    width: "90px",
    className: "col-emphasize",
  },
  {
    title: "Build",
    func: function (data) {
      return (
        '<a href="' +
        _getSeriesURL(data) +
        "/?part-number=" +
        data.series_name +
        data.layout_name +
        '" class="build"><span class="visually-hidden">Build</span></a>'
      );
    },
    width: "80px",
    className: "col-emphasize",
    noSort: true,
  },
  {
    title: "Performance Level",
    prop: "performance",
    format: "joinBreak",
    width: "110px",
    noSort: true,
  },
  {
    title: "Width of Male (mm)",
    prop: "width",
    format: "toFixed",
    width: "110px",
  },
  {
    title: "Height of Male (mm)",
    prop: "height",
    format: "toFixed",
    width: "110px",
  },
  {
    title: "Mounting",
    prop: "mounting",
    format: "joinBreak",
    width: "110px",
    noSort: true,
  },
  {
    title: "Termination",
    prop: "termination",
    format: "joinBreak",
    width: "110px",
    noSort: true,
  },
  {
    title: "Temp. Range",
    func: function (data) {
      return data.low_temp + "&deg; to " + data.high_temp + "&deg;";
    },
    width: "110px",
    noSort: true,
  },
  {
    title: "Waterproof",
    prop: "waterproof",
    format: "joinBreak",
    width: "110px",
    noSort: true,
  },
];

var openFaceTableDataTable, faceData;

var $faceListContainer = $(".face-list-container"),
  $openFaceItem = $("#face-open-face").hide(),
  $openFaceTable = $openFaceItem.find("table"),
  $pageOverlay = $(".comp-listing__overlay"),
  $curOpenFace = false;

function init(data, categorizationData) {
  faceData = {};

  if (!$.isPlainObject(categorizationData)) categorizationData = false;

  // organize faces by layout
  $.each(data, function (i, face) {
    if (!face.layout_name) return;

    if (typeof faceData[face.image] === "undefined")
      faceData[face.image] = {
        image: face.image,
        layouts: [],
      };

    faceData[face.image].layouts.push(face);
  });

  openFaceTableDataTable = $openFaceTable.DataTable({
    columns: dtUtils.buildDataTablesColumns(colData),
    fixedHeader: false,
    searching: false,
    lengthChange: false,
    info: false,
    order: [[1, "asc"]], // order by series
    dom: "t",
  });

  // add listeners
  $faceListContainer.on("click", "li.layout-item", function (e) {
    var $faceItem = $(e.currentTarget),
      layoutImg = $faceItem.data("layout-image");

    if ($faceItem.data("layout-count") == 1)
      document.location = _getSeriesURL(faceData[layoutImg].layouts[0]);
    else openFace($faceItem.data("layout-image"));
  });

  $(window).on("resize", function (e) {
    if ($curOpenFace !== false) positionFaceTable($curOpenFace);

    fixSafariFloatBug();
  });

  renderFaces(categorizationData);
}

function renderFaces(categorizationData) {
  if (!categorizationData) {
    var $faceList = createFaceList();

    $.each(faceData, function (layoutName, layout) {
      var $newItem = createListItem(layoutName, layout);

      // skip missing data
      if (!layoutName) return;

      $faceList.append($newItem[0]);
    });

    $faceListContainer.append($faceList);
  } else {
    var $faceLists = {};

    // create a faceList for each category
    $.each(categorizationData, function (layoutId, categoryName) {
      $faceLists[categoryName] = createFaceList();
    });

    $.each(faceData, function (layoutName, layout) {
      var $listItem = createListItem(layoutName, layout);

      // organize faces by the categorizationData
      $faceLists[categorizationData[layoutName]].append($listItem[0]);
    });

    // render cateogry title and faceList
    $.each($faceLists, function (categoryName, $faceList) {
      console.log(categoryName);

      // skip missing data
      if (!categoryName || categoryName == "undefined") return;

      $faceListContainer
        .append(
          '<h2 class="comp-list__category_title">' + categoryName + "</h2>"
        )
        .append($faceList);
    });
  }

  fixSafariFloatBug();
}

function createFaceList() {
  return $('<ul class="comp-listing face-list">');
}

function createListItem(layoutName, layout) {
  return $(
    '<li class="comp-listing__item mh layout-item" data-layout-count="' +
      layout.layouts.length +
      '" data-layout-image="' +
      layout.image +
      '">' +
      '<span class="comp-listing__notification">' +
      layout.layouts.length +
      "</span>" +
      '<div class="comp-listing__box comp-listing__box--reset">' +
      '<img src="' +
      window.SITE_SETTINGS.advSearchImageDir +
      "/" +
      layout.image +
      '" alt="' +
      layout.layouts[0].layout_name +
      ' Connector Layout">' +
      "</div>" +
      "</li>"
  );
}

function openFace(layoutImg) {
  var $face = $faceListContainer.find(
      '[data-layout-image="' + layoutImg + '"]'
    ),
    $lastFace = $(".comp-listing__item--active"),
    layoutData = faceData[layoutImg].layouts;

  // swap count with "X" on previous active item
  if ($lastFace.length > 0) {
    $lastFace
      .find(".comp-listing__notification")
      .text($lastFace.data("layout-count"));
    $lastFace.removeClass("comp-listing__item--active");
  }

  // if new face matches old face, close it (treat click as toggle)
  if ($lastFace.is($face)) {
    return $openFaceItem.slideUp(200, function () {
      changeOverlaysVisibility(false);
    });
  }

  // swap count with "X"
  $face.find(".comp-listing__notification").text("X");
  $face.addClass("comp-listing__item--active");

  $curOpenFace = $face;

  $openFaceItem.slideUp(200, function () {
    // redraw table with this layout's layouts
    openFaceTableDataTable
      .clear()
      .rows.add(dtUtils.formatResultsData(layoutData, colData))
      .draw();

    positionFaceTable($face);
    changeOverlaysVisibility(true);

    $openFaceItem.slideDown(200, function () {
      $("html, body").animate(
        {
          scrollTop: $face.offset().top - 40,
        },
        300
      );
    });
  });
}

function changeOverlaysVisibility(show) {
  if (show) {
    $pageOverlay.show();
    $('<li class="comp-listing__list_overlay" />').appendTo(
      $(".comp-listing__item--active").parent()
    );
  } else {
    $pageOverlay.hide();
    $(".comp-listing__list_overlay").remove();
  }
}

function getCurNumColumns() {
  var colBreakpoints = [
      { minWidth: 1024, cols: 5 },
      { minWidth: 768, cols: 4 },
      { minWidth: 568, cols: 3 },
      { minWidth: 480, cols: 2 },
      { minWidth: 1, cols: 1 },
    ],
    winW = $(window).width(),
    cols = 1;

  $.each(colBreakpoints, function (i, breakpoint) {
    if (winW < breakpoint.minWidth) return;

    cols = breakpoint.cols;
    return false;
  });

  return cols;
}

function positionFaceTable($listItem) {
  var $faceList = $listItem.parent(),
    curCols = getCurNumColumns(),
    faceCol,
    faceIndex,
    afterIndex;

  $openFaceItem.appendTo($faceList);

  faceIndex = $listItem.index() + 1;

  faceCol = faceIndex % curCols;
  if (faceCol == 0) faceCol = curCols;

  afterIndex = faceIndex + (curCols - faceCol);

  $openFaceItem.insertAfter($faceList.find("li:nth-child(" + afterIndex + ")"));
}

function fixSafariFloatBug() {
  var $layoutImgs = $(".layout-item img");

  $layoutImgs.css({
    height: "auto",
    width: "auto",
  });

  setTimeout(function () {
    $(".face-list").imagesLoaded(function () {
      var w = $layoutImgs.outerWidth(),
        h = $layoutImgs.outerHeight();

      $layoutImgs.each(function (i, el) {
        var $el = $(el);

        $el.width(w);
        $el.height(h);
      });
    });
  }, 1);
}

module.exports = {
  init: init,
};
